// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"2d6ef8a4","815":"3219a00f"}[chunkId] + ".chunk.css";
};